
import Hero from "../components/Hero";
import hotelImg from "../assests/images/hotel-bg.jpg";

import {
    FaShieldAlt,
    FaLock,
    FaUserSecret,
    FaCookieBite,
    FaInfoCircle,
    FaChevronRight,
    FaCheckCircle,
    FaArrowRight,
} from "react-icons/fa";

export default function PrivacyPolicy() {
    const quickLinks = [
        "Introduction",
        "Information We Collect",
        "How We Use Data",
        "Security",
        "Sharing",
        "Cookies",
        "Your Rights",
        "Contact",
    ];

    const trustPoints = [
        "Secure information handling",
        "Trusted service partners",
        "Privacy-focused practices",
    ];

    return (
        <div className="w-full overflow-hidden bg-[#F5F9FB]">

            {/* HERO */}
            <Hero
                variant="inner"
                title="Privacy Policy"
                subtitle="Your privacy matters to us. Learn how we collect, use and protect your information."
                backgroundImage={hotelImg}
            />

            {/* PRIVACY INTRO */}
            <section className="relative overflow-hidden bg-[#F5F9FB] py-14 sm:py-20 lg:py-24">

                <div className="pointer-events-none absolute -right-40 top-10 h-96 w-96 rounded-full bg-[#0B6E8E]/5 blur-3xl" />

                <div className="pointer-events-none absolute -left-40 bottom-0 h-80 w-80 rounded-full bg-[#F7B928]/10 blur-3xl" />

                <div className="relative z-10 mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">

                    <div className="grid grid-cols-1 items-stretch gap-6 lg:grid-cols-[1.4fr_0.6fr] lg:gap-8">

                        {/* INTRO CARD */}
                        <div className="group relative overflow-hidden rounded-[24px] border border-[#D8E5EB] bg-white p-7 shadow-[0_20px_60px_rgba(0,43,69,0.06)] transition-all duration-500 hover:shadow-[0_25px_70px_rgba(0,43,69,0.10)] sm:p-9 lg:p-12">

                            <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-[#002B45] to-[#FF5A1F]" />

                            <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:gap-6">

                                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#E8F4F8] text-[#FF5A1F] transition-all duration-300 group-hover:bg-[#FF5A1F] group-hover:text-white">
                                    <FaShieldAlt className="text-xl" />
                                </div>

                                <div className="min-w-0">

                                    <div className="mb-4 inline-flex items-center gap-3 rounded-full border border-[#0B6E8E]/10 bg-[#F5F9FB] px-4 py-2">

                                        <span className="h-1.5 w-1.5 rounded-full bg-[#F7B928]" />

                                        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#FF5A1F]">
                                            Your Privacy
                                        </span>

                                    </div>

                                    <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-[#002B45] sm:text-3xl lg:text-[40px]">
                                        Your Information
                                        <span className="block text-[#FF5A1F]">
                                            Matters to Us
                                        </span>
                                    </h2>

                                    <div className="mt-5 h-1 w-16 rounded-full bg-[#F7B928]" />

                                    <p className="mt-6 max-w-3xl text-sm leading-8 text-[#5B7180] sm:text-base">
                                        We are committed to protecting your
                                        personal information and maintaining
                                        your trust. This Privacy Policy explains
                                        how we collect, use and safeguard the
                                        information you provide when using our
                                        website and services.
                                    </p>

                                    <p className="mt-4 max-w-3xl text-sm leading-8 text-[#5B7180] sm:text-base">
                                        At Dubai Hotel Rates, we believe that
                                        a comfortable travel experience begins
                                        with confidence, transparency and
                                        responsible handling of your information.
                                    </p>

                                </div>
                            </div>
                        </div>

                        {/* TRUST CARD */}
                        <div className="group relative overflow-hidden rounded-[24px] bg-[#0B6E8E] p-7 shadow-[0_25px_70px_rgba(0,43,69,0.16)] transition-all duration-500 hover:-translate-y-1 sm:p-9 lg:p-10">

                            <div className="pointer-events-none absolute -right-20 -top-24 h-80 w-80 rounded-full border border-white/10 transition-transform duration-700 group-hover:scale-110" />

                            <div className="pointer-events-none absolute -bottom-28 -left-20 h-72 w-72 rounded-full bg-[#F7B928]/10 blur-3xl" />

                            <div className="relative z-10 flex h-full flex-col">

                                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#F7B928] text-[#002B45] shadow-lg">
                                    <FaLock className="text-2xl" />
                                </div>

                                <p className="mt-8 text-[10px] font-bold uppercase tracking-[0.22em] text-[#FFD778]">
                                    Our Commitment
                                </p>

                                <h3 className="mt-3 font-serif text-2xl font-bold leading-tight !text-white sm:text-3xl">
                                    Safe & Secure
                                    <span className="block text-[#FFD778]">
                                        Information
                                    </span>
                                </h3>

                                <p className="mt-4 text-sm leading-7 text-white/70">
                                    We take reasonable measures to help keep
                                    your personal information secure and
                                    handle it responsibly.
                                </p>

                                <div className="mt-8 space-y-4 border-t border-white/15 pt-6">

                                    {trustPoints.map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex items-center gap-3"
                                        >
                                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-white/10">
                                                <FaCheckCircle className="text-xs text-[#FFD778]" />
                                            </span>

                                            <span className="text-xs font-medium text-white/80 sm:text-sm">
                                                {item}
                                            </span>
                                        </div>
                                    ))}

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* MAIN POLICY AREA */}
            <section className="relative overflow-hidden bg-white py-14 sm:py-20 lg:py-24">

                <div className="pointer-events-none absolute -right-40 top-20 h-96 w-96 rounded-full bg-[#F7B928]/10 blur-3xl" />

                <div className="pointer-events-none absolute -left-40 bottom-0 h-96 w-96 rounded-full bg-[#0B6E8E]/5 blur-3xl" />

                <div className="relative z-10 mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">

                    {/* SECTION HEADING */}
                    <div className="mb-12 max-w-2xl">

                        <div className="mb-5 inline-flex items-center gap-3 rounded-full border border-[#0B6E8E]/10 bg-[#F5F9FB] px-4 py-2">

                            <span className="h-1.5 w-1.5 rounded-full bg-[#F7B928]" />

                            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#FF5A1F]">
                                Privacy & Protection
                            </span>

                        </div>

                        <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-[#002B45] sm:text-4xl lg:text-5xl">
                            Understanding Our
                            <span className="text-[#FF5A1F]">
                                {" "}Privacy Practices
                            </span>
                        </h2>

                        <div className="mt-5 h-1 w-16 rounded-full bg-[#F7B928]" />

                        <p className="mt-5 max-w-xl text-sm leading-8 text-[#5B7180] sm:text-base">
                            Explore how your information is collected,
                            used and protected when you interact with
                            Dubai Hotel Rates.
                        </p>

                    </div>

                    <div className="grid gap-8 lg:grid-cols-[280px_1fr]">

                        {/* DESKTOP SIDEBAR */}
                        <aside className="hidden lg:block">

                            <div className="sticky top-24 rounded-[22px] border border-[#D8E5EB] bg-white p-5 shadow-[0_10px_35px_rgba(0,43,69,0.045)]">

                                <div className="mb-5">

                                    <div className="flex items-center gap-2">

                                        <span className="h-px w-6 bg-[#F7B928]" />

                                        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#FF5A1F]">
                                            On This Page
                                        </p>

                                    </div>

                                    <h3 className="mt-2 text-lg font-extrabold text-[#002B45]">
                                        Quick Navigation
                                    </h3>

                                </div>

                                <div className="space-y-1">

                                    {quickLinks.map((item, index) => (

                                        <a
                                            key={index}
                                            href={`#section-${index}`}
                                            className="group flex items-center gap-3 rounded-xl px-3 py-3 text-xs font-semibold text-[#5B7180] transition-all duration-300 hover:bg-white hover:text-[#FF5A1F] hover:shadow-sm"
                                        >

                                            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white text-[9px] font-bold text-[#0B6E8E] transition-all duration-300 group-hover:bg-[#FF5A1F] group-hover:text-white">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>

                                            <span className="flex-1">
                                                {item}
                                            </span>

                                            <FaChevronRight className="text-[8px] opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100" />

                                        </a>

                                    ))}

                                </div>

                                <div className="mt-6 rounded-2xl bg-[#0B6E8E] p-4">

                                    <FaShieldAlt className="text-xl text-[#F7B928]" />

                                    <p className="mt-3 text-sm font-bold text-white">
                                        Your Privacy Matters
                                    </p>

                                    <p className="mt-2 text-xs leading-5 text-white/60">
                                        We are committed to responsible
                                        information handling.
                                    </p>

                                </div>

                            </div>
                        </aside>

                        {/* POLICY CONTENT */}
                        <div>

                            {/* MOBILE NAVIGATION */}
                            <div className="mb-6 lg:hidden">

                                <details className="group overflow-hidden rounded-2xl border border-[#D8E5EB] bg-[#F5F9FB]">

                                    <summary className="flex cursor-pointer list-none items-center justify-between px-5 py-4 text-sm font-bold text-[#002B45]">

                                        Privacy Policy Sections

                                        <FaChevronRight className="text-xs text-[#FF5A1F] transition-transform duration-300 group-open:rotate-90" />

                                    </summary>

                                    <div className="border-t border-[#D8E5EB] p-3">

                                        <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">

                                            {quickLinks.map((item, index) => (

                                                <a
                                                    key={index}
                                                    href={`#section-${index}`}
                                                    className="group flex items-center gap-3 rounded-xl px-3 py-3 text-xs font-semibold text-[#5B7180] transition-all duration-300 hover:bg-white hover:text-[#FF5A1F]"
                                                >

                                                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white text-[9px] font-bold text-[#0B6E8E] group-hover:bg-[#FF5A1F] group-hover:text-white">
                                                        {String(index + 1).padStart(2, "0")}
                                                    </span>

                                                    {item}

                                                </a>

                                            ))}

                                        </div>

                                    </div>

                                </details>
                            </div>

                            {/* POLICY CARD */}
                            <div className="overflow-hidden rounded-[24px] border border-[#D8E5EB] bg-white shadow-[0_20px_60px_rgba(0,43,69,0.06)]">

                                <div className="h-1 w-full bg-gradient-to-r from-[#002B45] via-[#0B6E8E] to-[#F7B928]" />

                                <div className="p-6 sm:p-8 lg:p-12">

                                    <div className="space-y-0">

                                        <Section
                                            id="section-0"
                                            number="01"
                                            icon={<FaInfoCircle />}
                                            title="Introduction"
                                            text="We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data."
                                        />

                                        <Section
                                            id="section-1"
                                            number="02"
                                            icon={<FaUserSecret />}
                                            title="Information We Collect"
                                            list={[
                                                "Personal details such as name, email and phone number",
                                                "Booking and travel preferences",
                                                "Payment information handled through secure systems",
                                                "Usage data including cookies and analytics information",
                                            ]}
                                        />

                                        <Section
                                            id="section-2"
                                            number="03"
                                            icon={<FaInfoCircle />}
                                            title="How We Use Your Information"
                                            list={[
                                                "Process bookings and payments",
                                                "Improve our website and user experience",
                                                "Send booking confirmations and relevant communications",
                                                "Provide customer support and respond to enquiries",
                                            ]}
                                        />

                                        <Section
                                            id="section-3"
                                            number="04"
                                            icon={<FaLock />}
                                            title="Data Security"
                                            text="We use reasonable security measures, including secure systems and appropriate safeguards, to help protect your personal information from unauthorized access, misuse or disclosure."
                                        />

                                        <Section
                                            id="section-4"
                                            number="05"
                                            icon={<FaShieldAlt />}
                                            title="Sharing of Information"
                                            text="We do not sell your personal information. Information may be shared with trusted service providers or partners when necessary to provide our services, process bookings or support your requests."
                                        />

                                        <Section
                                            id="section-5"
                                            number="06"
                                            icon={<FaCookieBite />}
                                            title="Cookies"
                                            text="We use cookies and similar technologies to improve your browsing experience, understand website usage and support certain website functionality. You can manage cookies through your browser settings."
                                        />

                                        <Section
                                            id="section-6"
                                            number="07"
                                            icon={<FaUserSecret />}
                                            title="Your Rights"
                                            text="You may request access to, correction of, or deletion of your personal information where applicable. You can contact our team if you have questions or requests regarding your personal data."
                                        />

                                        <Section
                                            id="section-7"
                                            number="08"
                                            icon={<FaInfoCircle />}
                                            title="Contact Us"
                                            text="If you have any questions or concerns about this Privacy Policy or how your information is handled, please contact our support team."
                                            last
                                        />

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="relative overflow-hidden bg-[#F5F9FB] px-5 pb-16 pt-8 sm:px-8 sm:pb-20 lg:px-12 lg:pb-28 xl:px-16">

                <div className="mx-auto max-w-[1440px]">

                    <div className="group relative overflow-hidden rounded-[24px] bg-[#0B6E8E] px-6 py-12 text-center shadow-[0_25px_70px_rgba(0,43,69,0.16)] transition-all duration-500 hover:shadow-[0_30px_80px_rgba(0,43,69,0.22)] sm:px-10 sm:py-16 lg:py-20">

                        <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full border border-white/10 transition-transform duration-700 group-hover:scale-110" />

                        <div className="pointer-events-none absolute -bottom-28 -right-20 h-80 w-80 rounded-full bg-[#F7B928]/10 blur-3xl" />

                        <div className="pointer-events-none absolute right-[10%] top-10 h-32 w-32 rounded-full border border-white/10" />

                        <div className="relative z-10 mx-auto max-w-2xl">

                            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#F7B928] text-2xl text-[#002B45] shadow-lg transition-transform duration-300 group-hover:-translate-y-1">
                                <FaShieldAlt />
                            </div>

                            <div className="mt-6 flex items-center justify-center gap-3">

                                <span className="h-px w-7 bg-[#F7B928]" />

                                <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#FFD778]">
                                    Your Privacy
                                </span>

                                <span className="h-px w-7 bg-[#F7B928]" />

                            </div>

                            <h2 className="mt-5 text-2xl font-extrabold leading-tight !text-white sm:text-3xl lg:text-4xl">
                                Your Privacy Is Important To Us
                            </h2>

                            <p className="mx-auto mt-5 max-w-xl text-sm leading-8 text-white/70 sm:text-base">
                                We are committed to handling your information
                                responsibly and providing a safe experience
                                throughout your journey with Dubai Hotel Rates.
                            </p>

                            <a
                                href="/contact-us"
                                className="group/btn mt-8 inline-flex items-center gap-3 rounded-full bg-[#F7B928] px-6 py-3.5 text-sm font-bold text-[#002B45] shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-[#FFD778] hover:shadow-xl"
                            >

                                Contact Our Team

                                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#002B45] text-[#F7B928] transition-transform duration-300 group-hover/btn:translate-x-1">
                                    <FaArrowRight className="text-[10px]" />
                                </span>

                            </a>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

/* =========================================================
   REUSABLE POLICY SECTION
========================================================= */

function Section({
    id,
    number,
    icon,
    title,
    text,
    list,
    last = false,
}) {
    return (
        <div
            id={id}
            className={`scroll-mt-24 ${!last
                ? "mb-8 border-b border-[#D8E5EB] pb-8 sm:mb-9 sm:pb-9"
                : ""
                }`}
        >

            <div className="group flex items-start gap-4 sm:gap-5">

                {/* NUMBER */}
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-[#D8E5EB] bg-[#E8F4F8] text-xs font-extrabold text-[#0B6E8E] transition-all duration-300 group-hover:bg-[#FF5A1F] group-hover:text-white sm:h-12 sm:w-12">
                    {number}
                </div>

                <div className="min-w-0 flex-1">

                    {/* HEADING */}
                    <div className="flex items-start gap-3">

                        <span className="mt-1 text-sm text-[#F7B928]">
                            {icon}
                        </span>

                        <h2 className="text-lg font-extrabold leading-tight text-[#002B45] transition-colors duration-300 group-hover:text-[#FF5A1F] sm:text-xl lg:text-2xl">
                            {title}
                        </h2>

                    </div>

                    {/* TEXT */}
                    {text && (
                        <p className="mt-4 text-sm leading-8 text-[#5B7180] sm:text-[15px]">
                            {text}
                        </p>
                    )}

                    {/* LIST */}
                    {list && (
                        <div className="mt-5 space-y-3">

                            {list.map((item, index) => (

                                <div
                                    key={index}
                                    className="group/item flex items-start gap-3 rounded-xl p-2 transition-colors duration-300 hover:bg-[#F5F9FB]"
                                >

                                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-[#E8F4F8] transition-colors duration-300 group-hover/item:bg-[#FF5A1F]">
                                        <FaCheckCircle className="text-[9px] text-[#0B6E8E] transition-colors duration-300 group-hover/item:text-white" />
                                    </span>

                                    <p className="text-sm leading-7 text-[#5B7180] sm:text-[15px]">
                                        {item}
                                    </p>

                                </div>

                            ))}

                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}